import { SelectItem, SelectItemGroup } from 'primeng/api';

export type GroupedAyaCourse = SelectItemGroup & { weight?: number; description?: string; iconUrl?: string; items: SelectItemAyaCourse[] };

type SelectItemAyaCourse = SelectItem & { weight?: number };
